


















import { Component, Mixins, Prop, Watch, Vue } from "vue-property-decorator";
import { MediaReferableContentMixin } from "./mixins";
import { ImageSourceKinds } from "../../../../../../domain/document";
import { ImageKinds } from "../../../../../../domain/document/ImageKinds";
import { ISize } from "../../../../../../domain/drawing";
import { instanceOfIWizardSizeSpecifiable, instanceOfIFixedTextIndicatable, instanceOfIWizardObjectProcessorContainable, IWizardContent } from "../../../../../../domain/format";
import { QuotedBadge, FatalIndicator } from "./common";
import { instanceOfIExecutable } from "./IExecutable";

@Component({
  components: {
    QuotedBadge,
    FatalIndicator,
    WizardContent: () => import("./WizardContent.vue"), // 再帰的に呼ばれるコンポーネントは動的import要.(単一コンポーネントでの再帰ならname指定でも回避可能？)
  }
})
export default class WizardContentMediaIndicator extends Mixins(MediaReferableContentMixin) {
  @Prop()
  scale: number;

  data() {
    return {
      imageStyle: {},
    };
  }
  imageStyle: {};

  $refs!: {
    image: HTMLImageElement,
    content: Vue,
  };

  get text(): string {
    const text = instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : null;
    return text ? text : "画像エリア";
  }

  get classes(): unknown[] {
    return [
      "wizard-content-media-indicator",
      this.isProcessible ? "wizard-content-media-indicator-processible" : null,
    ].filter(c => !!c);
  }

  get contentStyle(): {} {
    return this.size;
  }

  get size(): ISize<string> {
    return (instanceOfIWizardSizeSpecifiable(this.content) && this.content.size)
      ? this.content.size
      // 未指定の場合は50vminで.オブジェクトの情報は取らない.(入力フォームの情報はテンプレートで閉じる.)
      : {
        width: "50vmin",
        height: "50vmin",
      };
  }

  get hasImage(): boolean {
    return !!this.imageDrawable && !!this.imageUrl
      ? this.imageDrawable.imageKind === ImageKinds.Image || this.imageDrawable.imageKind === ImageKinds.ClaioImage || this.imageDrawable.imageKind === ImageKinds.ClaioSchema
      : false;
  }

  get rotationAngle(): number {
    return !!this.imageDrawable
      ? this.imageDrawable.rotationAngle
      : 0;
  }

  get imageUrl(): string {
    return !!this.imageSource && this.imageSource.imageSourceKind !== ImageSourceKinds.None
      ? this.imageSource.source
      : null;
  }

  get processor(): IWizardContent {
    return instanceOfIWizardObjectProcessorContainable(this.content)
      ? this.content.processor
      : null;
  }

  get isProcessible(): boolean {
    return !!this.processor;
  }

  async process() {
    if (instanceOfIExecutable(this.$refs.content)) {
      await this.$refs.content.execute();
    }
  }

  @Watch("imageDrawable")
  onImageDrawableUpdated() {
    this.imageStyle = this.hasImage
      ? this.toImageStyle(this.$refs.image, this.rotationAngle)
      : {};
  }

  onImageLoaded() {
    this.imageStyle = this.toImageStyle(this.$refs.image, this.rotationAngle);
  }

  private toImageStyle(element: HTMLImageElement, rotationAngle: number): {} {
    if (!element) {
      return {};
    }
    const container = element.parentElement;
    const rect = container.getBoundingClientRect();
    const ratioWidth = element.naturalWidth / (rect.width > 0 ? rect.width : 1);
    const ratioHeight = element.naturalHeight / (rect.height > 0 ? rect.height : 1);
    const ratioRotateWidth = element.naturalWidth / (rect.height > 0 ? rect.height : 1);
    const ratioRotateHeight = element.naturalHeight / (rect.width > 0 ? rect.width : 1);

    // 回転時の拡大率を算出する
    const ratioScale = (ratioRotateWidth < ratioRotateHeight)
      ? (ratioWidth > ratioHeight)
        ? element.naturalWidth / element.naturalHeight
        : rect.width / rect.height
      : (ratioWidth < ratioHeight)
        ? element.naturalHeight / element.naturalWidth
        : rect.height / rect.width;

    const scaleText = ((rotationAngle % 180 !== 0) && ratioScale)
      ? " scale(" + ratioScale + ")"
      : "";

    return {
      transform: "rotate(" + rotationAngle + "deg)" + scaleText,
      width: this.size.width,
      height: this.size.height,
    };
  }
}
